<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-business-card-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.667 6C43.955 6 45 6.895 45 8v32c0 1.105-1.045 2-2.333 2H5.333C4.045 42 3 41.105 3 40V8c0-1.105 1.045-2 2.333-2h37.334zM25 30a1 1 0 011 1v2a1 1 0 01-1 1H11a1 1 0 01-1-1v-2a1 1 0 011-1h14zm-7-8a1 1 0 011 1v2a1 1 0 01-1 1h-7a1 1 0 01-1-1v-2a1 1 0 011-1h7zm19-9a1 1 0 011 1v11a1 1 0 01-1 1h-9a1 1 0 01-1-1V14a1 1 0 011-1h9zm-3 4h-3v5h3v-5z"/></svg>
</template>
<script>

export default {
  name: 'IconBusinessCardFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
